import styled from "styled-components";

import { Image as LibImage } from "@components/DataDisplay/Image";

export const Root = styled.aside`
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: -1;
`;

export const Image = styled(LibImage)`
  position: absolute;
  bottom: 0;
  right: -10%;
  max-height: 100%;
  width: calc(718px / 2);
  height: calc(1336px / 2);
  z-index: -1;

  @media (min-width: 365px) {
    right: 0;
  }

  ${props => props.theme.breakpointsV2.largeMobile} {
    ${props => props.theme.orientation.portrait} {
      width: 55vh;
      height: 85vh;
      right: -10vh;
    }
  }

  ${props => props.theme.breakpointsV2.smallTablet} {
    ${props => props.theme.orientation.landscape} {
      width: calc(920px / 2);
      height: calc(1364px / 2);
    }
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    width: 44.2%;
    height: 100%;
  }

  img {
    object-fit: contain;
    object-position: bottom right;
  }
`;
